


































import { Component, Prop } from 'vue-property-decorator'

import { GroupedBotProperty } from '../../../../../../../../../BotProperties/components/Properties/types'
import { UseFields } from '../../../../../../../../../Pi'
import findPropertyById from '../../../../../../Helpers/findPropertyById'
import BetweenCondition from '../../../logic/ConditionTypes/BetweenPropertyCondition'
import CalculateValue from '../../../logic/PropertyConditionValues/CalculateValue'
import ConstantValue from '../../../logic/PropertyConditionValues/ConstantValue'
import PropertyValue from '../../../logic/PropertyConditionValues/PropertyValue'

@Component
export default class BetweenConditionView extends UseFields {
  @Prop() condition!: BetweenCondition

  @Prop() properties!: Array<GroupedBotProperty>

  get leftValue(): string | null {
    if (this.condition.left instanceof PropertyValue) {
      const propId = this.condition.left.property_index
      const property = findPropertyById(this.properties, propId)

      if (property) {
        return property.name ?? property.type
      }
    }

    return null
  }

  get fromValue(): string | number | null {
    if (this.condition.from instanceof PropertyValue) {
      const propId = this.condition.from.property_index
      const property = findPropertyById(this.properties, propId)

      if (property) {
        return property.name ?? property.type
      }
    }

    if (this.condition.from instanceof ConstantValue || this.condition.from instanceof CalculateValue) {
      return this.condition.from.value
    }

    return null
  }

  get toValue(): string | number | null {
    if (this.condition.to instanceof PropertyValue) {
      const propId = this.condition.to.property_index
      const property = findPropertyById(this.properties, propId)

      if (property) {
        return property.name ?? property.type
      }
    }

    if (this.condition.to instanceof ConstantValue || this.condition.to instanceof CalculateValue) {
      return this.condition.to.value
    }

    return null
  }
}
